import { mapActions, mapState } from 'vuex';

import funcoes from "../../util/funcoes.js";
import { BANCOS, STATUS_CONTRATO_ALUGUEL, FORMA_PAGAMENTO, OPERACAO_IMOVEL, STATUS_CONTRATO } from "../../util/constantes";
import { MENSAGEM_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB, TITULO_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB } from "../../util/strings";
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faIdBadge,faPercent } from '@fortawesome/free-solid-svg-icons';
import AppStatusEnvioExtratos from './dialogs/StatusEnvioExtratos.vue'

library.add(faIdBadge, faPercent)
export default {
	components: {
		FontAwesomeIcon,
		AppStatusEnvioExtratos
	},

	data() {
		return {
			dimob: {
				anoBase: funcoes.anoBaseDimob(),
				idContrato: undefined
			},

			declararIr: false,

			regras: {
				anoBase: [
					{ required: true, validator: this.validarAnoBase },
				],
			},
			visibilidadeStatusEnvioExtratos: false,
			payloadEnvioExtratos: undefined
		};
	},

	created() {
		this.exibirInfosSobreDimob()
	},

	computed: {
		...mapState('dimobStore', {
			contratosRecuperados(state) { return state.contratos },
		}),

		formasPagamento() {
			return FORMA_PAGAMENTO;
		},
		bancos() {
			return BANCOS;
		},

		contratos() {
			return this.contratosRecuperados
				.filter(this.filtrarPorDeclararIr);
		},

		contratosSelecionados() {
			return this.contratos
				.filter(this.filtrarPorSelecionado);
		},
	},

	methods: {
		...mapActions([
			'showLoading',
			'hideLoading',
		]),
		
		...mapActions('dimobStore', {
			listarProprietarios: 'listarProprietarios',
			dispatchGerarEtiquetas: 'gerarEtiquetas',
			dispatchGerarExtratos: 'gerarExtratos',
			dispatchGerarArquivoImportacao: 'gerarArquivoImportacao',
			selecionarTodos: 'selecionarTodos',
			deselecionarTodos: 'deselecionarTodos',
			enviarExtratosEmail: 'enviarExtratosEmail'
		}),

		validarAnoBase(rule, value, callback) {
			if(isNaN(Number(value)) || String(value).length !== 4) {
				return callback(new Error());
			}

			return callback();
		},

		pesquisar() {
			const payload = { ...this.dimob };
			this.showLoading();

			this.listarProprietarios(payload)
				.then()
				.catch(() => {
					this.$message.error("Não foi possível conectar-se ao servidor");
				})
				.finally(() => {
					this.hideLoading();
				});
		},

		filtrarPorDeclararIr(contrato) {
			return this.declararIr
				? contrato.declararIr
				: true;
		},

		filtrarPorSelecionado(contrato) {
			return contrato.selecionado;
		},

		gerarEtiquetas() {
			if (this.contratosSelecionados.length === 0) {
				this.exibirAlerta("Selecione pelo menos um Contrato");
				return;
			}

			const payload = this.getPayloadEtiquetas();
			this.showLoading();

			this.dispatchGerarEtiquetas(payload)
				.then(this.resolverGerarEtiquetas)
				.catch(() => {
					this.$message.error("Não foi possível conectar-se ao servidor");
				})
				.finally(() => {
					this.hideLoading();
				});
		},

		getPayloadEtiquetas() {
			return {
				clientes: this.getIdsProprietarios(),
			};
		},

		getIdsProprietarios() {
			const mapearIdDoProprietario = contrato => contrato.imovel.proprietariosBeneficiarios[0].id;

			return this.contratosSelecionados.map(mapearIdDoProprietario);
		},

		resolverGerarEtiquetas(resultado) {
			this.baixarArquivo(resultado.data, 'Etiquetas.xls');
		},

		gerarExtratos() {
			this.$refs.form.validateField('anoBase', error => {
				if(error) {
					this.exibirAlerta('Preencha o Ano Base');
					return;
				}

				if (this.contratosSelecionados.length === 0) {
					this.exibirAlerta("Selecione pelo menos um Contrato");
					return
				}

				const payload = this.getPayloadExtratos();
				this.showLoading();

				this.dispatchGerarExtratos(payload)
					.then(this.resolverGerarExtratos)
					.catch(() => {
						this.$message.error("Não foi possível conectar-se ao servidor");
					})
					.finally(() => {
						this.hideLoading();
					});
			})
		},

		getPayloadExtratos() {
			return {
				alugueis: this.getIdsAlugueis(),
				vendas: this.getIdsVendas(),
				anoBase: this.dimob.anoBase,
			};
		},

		getPayloadExtratosEmail() {
			return {
				alugueisEnviarEmail: this.getAlugueis(),
				vendasEnviarEmail: this.getVendas(),
				anoBase: this.dimob.anoBase
			}
		},

		resolverGerarExtratos(resultado) {
			this.baixarArquivo(resultado.data, 'Dimob.zip');
		},

		gerarArquivoImportacao() {
			this.$refs.form.validateField('anoBase', error => {
				if(error) {
					this.exibirAlerta('Preencha o Ano Base');
					return;
				}

				if (this.contratosSelecionados.length === 0) {
					this.exibirAlerta("Selecione pelo menos um Contrato");
					return;
				}

				this.$confirm(MENSAGEM_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB, TITULO_CONFIRMACAO_GERAR_ARQUIVO_IMPORTACAO_DIMOB, {
					confirmButtonText: "Confirmar",
					cancelButtonText: "Cancelar",
					type: "warning"
				}).then(() => {
					this.showLoading()

					const payload = this.getPayloadArquivoImportacao();

					this.dispatchGerarArquivoImportacao(payload)
						.then(this.resolverGerarArquivoImportacao)
						.catch(() => {
							this.$message.error("Não foi possível conectar-se ao servidor");
						})
						.finally(() => {
							this.hideLoading();
						});
				});
			});
		},

		getPayloadArquivoImportacao() {
			return {
				alugueis: this.getIdsAlugueis(),
				vendas: this.getIdsVendas(),
				anoBase: this.dimob.anoBase,
			};
		},

		resolverGerarArquivoImportacao(resultado) {
			const arquivo = resultado.data;
			const nome = 'Dimob' + this.dimob.anoBase + '.txt';
			
			this.baixarArquivo(arquivo, nome);
		},

		baixarArquivo(arquivo, nome) {
			const url = window.URL.createObjectURL(new Blob([arquivo]));
			const anchor = document.createElement('a');
			anchor.href = url;
			anchor.setAttribute('download', nome);
			document.body.appendChild(anchor);
			anchor.click();
		},

		getIdsAlugueis() {
			return this.contratosSelecionados
				.filter(contrato => contrato.tipoContrato === 'ALUGUEL')
				.map(contrato => contrato.id);
		},

		getIdsVendas() {
			return this.contratosSelecionados
				.filter(contrato => contrato.tipoContrato === 'VENDA')
				.map(contrato => contrato.id);
		},

		getAlugueis() {
			return this.contratosSelecionados
				.filter(contrato => contrato.tipoContrato === 'ALUGUEL')
				.map(contrato => {
					return { ...contrato, tipoContrato: undefined, selecionado: undefined }
				})
		},

		getVendas() {
			return this.contratosSelecionados
			.filter(contrato => contrato.tipoContrato === 'VENDA')
			.map(contrato => {
				return { ...contrato, tipoContrato: undefined, selecionado: undefined }
			})
		},

		exibirAlerta(mensagem) {
			this.$alert(mensagem, 'Atenção', { confirmButtonText: 'OK', type: 'error' });
		},

		getLabelTipoContrato(contrato) {
			return funcoes.getLabel(OPERACAO_IMOVEL, contrato.tipoContrato);
		},
		getLabelStatus(contrato) {
			return funcoes.getLabel([...STATUS_CONTRATO_ALUGUEL, ...STATUS_CONTRATO], contrato.status);
		},
		getLabelId(contrato) {
			return contrato.tipoContrato === 'ALUGUEL' ? contrato.idNaImobiliaria : contrato.imovel.idNaImobiliaria;
		},
		getLabelDeclararIr(contrato) {
			return contrato.declararIr ? 'Sim' : 'Não';
		},
		
		limparCampos() {
			this.dimob = {
				anoBase: funcoes.anoBaseDimob(),
				idContrato: undefined,
			}
		},

		exibirInfosSobreDimob() {
			this.$alert(
				'Para listagem do contrato ocorrer na lista, o CEP do imóvel cadastrado deve estar preenchido.', 
				'Atenção', {
					confirmButtonText: 'Ok'
				});
		},

		enviarExtratosEmail() {
			this.$refs.form.validateField('anoBase', error => {
				if(error) {
					this.exibirAlerta('Preencha o Ano Base');
					return;
				}

				if(this.contratosSelecionados.length === 0) {
					this.exibirAlerta("Selecione pelo menos um Contrato");
					return;
				}

				this.payloadEnvioExtratos = this.getPayloadExtratosEmail()
				this.visibilidadeStatusEnvioExtratos = true;
			});
		},
		fecharEnviarExtratosEmail() {
			this.visibilidadeStatusEnvioExtratos = false;
		}
	},
};